export const TERMINAL_TRADE_EVENT_STATUSES = new Set([
  'fill',
  'filled',
  'cash_settled',
  'assigned',
  'assignment',
  'exercised',
  'exercise',
  'expired',
]);

export const normalizeTradeStatus = (status) =>
  String(status || '').toLowerCase().trim();

export const isTerminalTradeEventStatus = (status) =>
  TERMINAL_TRADE_EVENT_STATUSES.has(normalizeTradeStatus(status));
